module.exports = __webpack_public_path__ + "00_hair.0f5669fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/00_hair.png
// module id = 3gKU
// module chunks = 0